// extracted by mini-css-extract-plugin
export default {"rating-container":"rating-container","adjust-full-space":"adjust-full-space"};
    if(module.hot) {
      // 1793340219657
      var cssReload = require("/home/vsts/work/1/s/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  